<template>
  <div id="index" class="banlijianzhuxuke">
    <top :defaultIndex="1"></top>
    <div class="banlijianzhuxukebody">
      <div class="left">
        <ditu :list="list2"></ditu>
      </div>
      <div class="right">
        <div class="right1">
          <paiming :title="title" :list="list"></paiming>
          <chengben></chengben>
        </div>
        <div class="right2">
          <toubiao></toubiao>
          <jiankong></jiankong>
          <pinggu></pinggu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import top from "@/components/head/top";
import paiming from "@/components/zhengfucaigou/paiming";
import chengben from "@/components/zhengfucaigou/chengben";
import jiankong from "@/components/zhengfucaigou/jiankong";
import pinggu from "@/components/zhengfucaigou/pinggu";
import toubiao from "@/components/zhengfucaigou/toubiao";
import ditu from "@/components/ditu";

export default {
  data() {
    return {
      loading: true,
      title: '政府釆购得分',
      list2: [
        {
          title: '大连', fen: '95', paiming: 2,
          list: [
            {title: '互联网+招标采购得分', desc: '2.2年'},
            {title: '投标和履约担保得分', desc: '800元'},
            {title: '外地企业中标率', desc: '85 %'},
            {title: '投诉机制得分', desc: '85分'},
          ],
        }, {
          title: '北京', fen: '90', paiming: 2,
          list: [
            {title: '互联网+招标采购得分', desc: '2.2年'},
            {title: '投标和履约担保得分', desc: '800元'},
            {title: '外地企业中标率', desc: '85 %'},
            {title: '投诉机制得分', desc: '85分'},
          ],
        }, {
          title: '上海', fen: '96', paiming: 2,
          list: [
            {title: '互联网+招标采购得分', desc: '2.2年'},
            {title: '投标和履约担保得分', desc: '800元'},
            {title: '外地企业中标率', desc: '85 %'},
            {title: '投诉机制得分', desc: '85分'},
          ],
        }, {
          title: '深圳', fen: '90', paiming: 2,
          list: [
            {title: '互联网+招标采购得分', desc: '2.2年'},
            {title: '投标和履约担保得分', desc: '800元'},
            {title: '外地企业中标率', desc: '85 %'},
            {title: '投诉机制得分', desc: '85分'},
          ],
        }],
      list: [{
        title: '上海',
        fenshu: 96
      }, {
        title: '大连',
        fenshu: 95
      }, {
        title: '北京',
        fenshu: 90
      }, {
        title: '深圳',
        fenshu: 90
      }]
    };
  },
  components: {
    top,
    paiming,
    chengben,
    jiankong,
    pinggu,
    ditu,
    toubiao
  },
  mounted() {
    this.cancelLoading();
  },
  methods: {
    cancelLoading() {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../main";

.banlijianzhuxuke {
  width: 3840px;
  height: 2160px;
  position: relative;
  background: url("../assets/banlijianzhuxukebg.png") no-repeat;

  .banlijianzhuxukebody {
    @include flex_between_start();


    .left {
      width: 1657px;
    }

    .right {
      margin-right: 80px;
      width: 2180px;
      margin-top: 260px;
      @include flex_start_start();

      .right1 {
        width: 772px;
        margin-right: 80px;
      }

      .right2 {
        width: 1244px;
      }
    }
  }
}
</style>
